// Fund History Debit type
export const REQUEST_DEBIT = "expense"; // make a expense's request that is send as request for approbation
export const DIRECT_DEBIT = "other"; // make a expense that impact directly cash register (I used "other" because client doesn't expess the need to impact directly the cash register)

// Expense type
export const ADMIN_EXPENSE = "admin";
export const PROJECT_EXPENSE = "project";
export const LAB_EXPENSE = "labo";
export const EXPENSE_TYPES = [
    {text: "Administrative", value: ADMIN_EXPENSE},
    {text: "Projet", value: PROJECT_EXPENSE},
    {text: "Offre", value: PROJECT_EXPENSE},
    {text: "Laboratoire", value: LAB_EXPENSE},
];

// Bank Modal type
export const DEBIT_MODAL = "exit"; // make a withdraw (or expense)
export const CREDIT_MODAL = "entry"; // make a deposit
export const TRANSFER_MODAL = "transfer"; // transfer from one bank to another

// Bank Operations
export const CREDIT_TYPE = "credit";
export const DEBIT_TYPE = "debit";

// Bank Transaction Type
export const CREDIT_OPERATION = "credit";
export const REQUEST_OPERATION = "request";
export const TRANSFER_OPERATION = "transfer";
export const EXPENSE_OPERATION = "other";
